var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPinOtherStoreDefaultLtr = function SvgPinOtherStoreDefaultLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17 33.29C17 14.934 31.804 0 50 0s33 14.934 33 33.29a33.6 33.6 0 0 1-3.83 15.578c-4.974 9.463-26.056 48.331-26.792 49.688l-.018.033A2.69 2.69 0 0 1 50 100h-.003c-.984 0-1.89-.544-2.36-1.417l-.701-1.3c-3.75-6.951-21.4-39.672-25.951-48.123A33.6 33.6 0 0 1 17 33.29m51-9.616C68 22.75 67.25 22 66.326 22H33.674C32.75 22 32 22.75 32 23.674v23.442c0 .925.75 1.675 1.674 1.675h9.628V33.302h13.814v15.489h9.21c.924 0 1.674-.75 1.674-1.675zM50 35.797c.578 0 1.047.468 1.047 1.046V46a1.046 1.046 0 1 1-2.093 0v-9.157c0-.578.468-1.047 1.046-1.047",
    clipRule: "evenodd"
  })));
};
export default SvgPinOtherStoreDefaultLtr;